/* eslint-disable camelcase */
import classNames from "classnames";
import { useLocation, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { animated, useSpring } from "@react-spring/web";
import { makeLangUrl } from "helpers/makeLangUrl";
import { CATEGORIES_ENUMS } from "constants/navigation/categories";
import { GET_PARAMS } from "constants/popupConfig";
import { isUrlActive } from "helpers/is";
import useQueryParam from "hooks/useQueryParam";
import useTranslate from "hooks/useTranslate";
import { CategoryType } from "redux/game/slice";

import "./styles.sass";

type CategoryNavigationItemProps = {
  item: CategoryType;
  isLoading: boolean;
  isSidebarOpen: boolean;
  customColor?: string;
  onCategorySelect: (category: CATEGORIES_ENUMS) => void;
};

const CategoryNavigationItem = (props: CategoryNavigationItemProps) => {
  const { item, isLoading, isSidebarOpen, customColor, onCategorySelect } =
    props;
  // eslint-disable-next-line unused-imports/no-unused-vars
  const { id, icon, image, title, url } = item;
  const category = useQueryParam(GET_PARAMS.CATEGORY);
  const location = useLocation();

  const navigate = useNavigate();
  const t = useTranslate();

  const widthItem = isSidebarOpen ? 240 : 44;

  const { opacity, x, width } = useSpring({
    opacity: isSidebarOpen ? 1 : 0,
    x: isSidebarOpen ? 8 : 16,
    width: widthItem,
  });

  const handleClick = () => {
    onCategorySelect(id);
    navigate(makeLangUrl(url));
  };

  const sidebarItemClass = classNames("CategoryNavigationItem", {
    active:
      category === id ||
      (!category &&
        id === CATEGORIES_ENUMS.POPULAR &&
        location.pathname === "/") ||
      (isUrlActive(url) && !category),
    short: !isSidebarOpen,
  });
  const iconClass = classNames("CategoryNavigationItem__icon", {
    CategoryNavigationItem__icon_custom: !!customColor,
  });

  return (
    <animated.button
      onClick={handleClick}
      className={sidebarItemClass}
      style={{ x, width }}
    >
      {isLoading && (
        <div className="CategoryNavigationItem__loading">
          <Skeleton width={widthItem} height={44} />
        </div>
      )}
      <div className={iconClass} style={{ fill: customColor }}>
        {icon}
      </div>
      <animated.div
        className="CategoryNavigationItem__title"
        style={{ opacity }}
      >
        {t(title)}
      </animated.div>
    </animated.button>
  );
};

export default CategoryNavigationItem;
